import { render, staticRenderFns } from "./SicknessReports.vue?vue&type=template&id=f7b0d108&scoped=true&"
import script from "./SicknessReports.vue?vue&type=script&lang=js&"
export * from "./SicknessReports.vue?vue&type=script&lang=js&"
import style0 from "./SicknessReports.vue?vue&type=style&index=0&id=f7b0d108&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b0d108",
  null
  
)

export default component.exports